module.exports = __webpack_public_path__ + "static/media/store03.9d8b6053.jpg";